import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconCompassBlack({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path id="a" d="M0 .254h21.731v21.384H.001z" />
			</defs>
			<g fill="none" fillRule="evenodd">
				<g transform="translate(3.34 3.394)scale(.78473)">
					<mask id="b" fill="#fff">
						<use xlinkHref="#a" width="100%" height="100%" />
					</mask>
					<path
						fill="#000"
						d="M10.866 1.003c-2.7 0-5.24 1.034-7.149 2.912a9.84 9.84 0 0 0 0 14.062 10.13 10.13 0 0 0 7.149 2.912c2.7 0 5.239-1.034 7.148-2.912a9.84 9.84 0 0 0 0-14.062 10.13 10.13 0 0 0-7.148-2.912m0 20.635a10.9 10.9 0 0 1-7.687-3.132 10.58 10.58 0 0 1 0-15.12A10.9 10.9 0 0 1 10.866.254c2.904 0 5.633 1.112 7.687 3.132a10.58 10.58 0 0 1 0 15.12 10.9 10.9 0 0 1-7.687 3.132"
						mask="url(#b)"
					/>
				</g>
				<path
					fill="#de1b12"
					d="M8.979 15.1a.3.3 0 0 1-.211-.087.29.29 0 0 1 0-.415l5.003-4.92a.303.303 0 0 1 .423 0 .29.29 0 0 1 0 .416l-5.003 4.92a.3.3 0 0 1-.212.085m-1.228 1.209-.04-.002-1.35-.182a.295.295 0 0 1-.257-.33.297.297 0 0 1 .337-.251l1.35.18a.295.295 0 0 1 .256.331.3.3 0 0 1-.295.254"
				/>
				<path
					fill="#de1b12"
					d="M6.4 16.127a.3.3 0 0 1-.212-.087.29.29 0 0 1 0-.415l1.983-1.95a.3.3 0 0 1 .423 0 .29.29 0 0 1 0 .416l-1.983 1.95a.3.3 0 0 1-.211.086"
				/>
				<path
					fill="#de1b12"
					d="M9.795 14.297H9.77l-1.412-.121a.295.295 0 0 1-.272-.319.3.3 0 0 1 .323-.267l1.413.121a.296.296 0 0 1 .272.318.297.297 0 0 1-.299.268m-1.829 3.37a.3.3 0 0 1-.296-.253l-.184-1.33a.295.295 0 0 1 .256-.33.295.295 0 0 1 .336.251l.184 1.329a.295.295 0 0 1-.296.333"
				/>
				<path
					fill="#de1b12"
					d="M7.965 17.667a.3.3 0 0 1-.211-.086.29.29 0 0 1 0-.415l1.983-1.95a.3.3 0 0 1 .422 0 .29.29 0 0 1 0 .415l-1.983 1.95a.3.3 0 0 1-.21.086"
				/>
				<path
					fill="#de1b12"
					d="M9.948 15.716a.297.297 0 0 1-.297-.267l-.124-1.39a.295.295 0 0 1 .272-.317.297.297 0 0 1 .324.267l.123 1.389a.295.295 0 0 1-.298.318m4.066-5.567a.295.295 0 0 1-.297-.334l.246-1.75a.297.297 0 0 1 .337-.252.294.294 0 0 1 .254.331l-.245 1.751a.3.3 0 0 1-.295.254"
				/>
				<path
					fill="#de1b12"
					d="M14.259 8.398a.293.293 0 0 1-.102-.57l2.515-.906a.3.3 0 0 1 .384.175.293.293 0 0 1-.178.377l-2.517.905a.3.3 0 0 1-.102.018"
				/>
				<path
					fill="#de1b12"
					d="M15.824 9.937a.3.3 0 0 1-.107-.02.29.29 0 0 1-.172-.378l.952-2.446a.3.3 0 0 1 .385-.169.29.29 0 0 1 .173.38l-.952 2.444a.3.3 0 0 1-.279.189"
				/>
				<path
					fill="#de1b12"
					d="M14.013 10.149a.3.3 0 0 1-.297-.26.295.295 0 0 1 .262-.326l1.81-.212a.3.3 0 0 1 .333.258.295.295 0 0 1-.261.326l-1.812.212z"
				/>
				<path
					fill="#de1b12"
					d="M14.477 10.665a.3.3 0 0 1-.212-.086l-.985-.968a.29.29 0 0 1 0-.416.3.3 0 0 1 .422 0l.986.97a.29.29 0 0 1 0 .415.3.3 0 0 1-.212.086"
				/>
			</g>
		</svg>
	);
}
